const BOTTOM_LEFT = {lat: 47.2, lng: 5.2};

export function coordinatesToCellCenter(coordinates, cellsize = 10) {
    const kmCoordinates = coordinateDifferenceInKm(coordinates, BOTTOM_LEFT);
    const cell = gridCellFromKm(kmCoordinates, cellsize);
    return cellToCenterCoordinates(cell);
}

export function coordinatesToCellPolygon(coordinates, cellsize = 10) {
    const kmCoordinates = coordinateDifferenceInKm(coordinates, BOTTOM_LEFT);
    const cell = gridCellFromKm(kmCoordinates, cellsize);
    return cellToPolygon(cell);
}

function coordinateDifferenceInKm(latlng1, latlng2) {
    const dy = 111.3 * (latlng1.lat - latlng2.lat);
    const dx = 71.5 * (latlng1.lng - latlng2.lng);
    const distance = Math.sqrt(dx * dx + dy * dy);
    return {
        y: dy,
        x: dx,
        distance
    }
}

function kmToCoordinates(kmCoordinates, positionOffset) {
    const lat = kmCoordinates.y / 111.3 + positionOffset.lat;
    const lng = kmCoordinates.x / 71.5 + positionOffset.lng;
    return {
        lat,
        lng
    }
}

/**
 * @param {object} kmCoordinates The coordinates to get cell for.
 * @param {number} cellsize The size of a cell in km.
 * @return {object} {x: int, y: int} the indizes of the grid cell.
 */
function gridCellFromKm(kmCoordinates, cellsize = 10) {
    if (!kmCoordinates)
        return null;
    const x = Math.floor(kmCoordinates.x / cellsize);
    const y = Math.floor(kmCoordinates.y / cellsize);
    return {
        x,
        y
    }
}

// cellIndizes is { x: int, y: int }
function cellToCenterCoordinates(cellIndizes, cellsize = 10) {
    const x = (cellIndizes.x + 0.5) * cellsize;
    const y = (cellIndizes.y + 0.5) * cellsize;
    return kmToCoordinates({x, y}, BOTTOM_LEFT);
}

function cellToPolygon(cellIndizes, cellsize = 10) {
    const left = (cellIndizes.x) * cellsize;
    const right = (cellIndizes.x + 1) * cellsize;
    const bottom = (cellIndizes.y + 1) * cellsize;
    const top = (cellIndizes.y) * cellsize;
    const bottomLeft = kmToCoordinates({x: left, y: bottom}, BOTTOM_LEFT);
    const bottomRight = kmToCoordinates({x: right, y: bottom}, BOTTOM_LEFT);
    const topLeft = kmToCoordinates({x: left, y: top}, BOTTOM_LEFT);
    const topRight = kmToCoordinates({x: right, y: top}, BOTTOM_LEFT);
    return [[bottomLeft.lat, bottomLeft.lng], [bottomRight.lat, bottomRight.lng], [topRight.lat, topRight.lng], [topLeft.lat, topLeft.lng]];
}